import { createFileRoute } from "@tanstack/react-router";

import PackingSlipReview from "../-components/ShipMetal/PackingSlipReview";

export const Route = createFileRoute("/_authenticated/trade/ship-metal/packing-slip")({
  component: PackingSlipReview,
  context: () => ({ permissions: "trade.ship" }),
});
